<template>
 <div class="preloader-container d-flex justify-content-center align-items-center">
    <div class="preloader text-center d-flex flex-column">
      <div style="display:flex;flex-direction: column;gap:10px;align-items: center;">
        <!-- <a :href="portalUrl">
          <v-img :src="require('@/assets/images/t2t4 lOGO.jpg')" class="portal_logo" @click="$router.push('/')" />
        </a> -->
        <v-img :src="require('@/assets/images/t2t4 lOGO.jpg')" class="portal_logo"  style="width:300px"/>
        <img src="../assets/loader_v2.gif" alt="Loading..." style="width: 180px;">
      </div>
      <div class="text-center mt-4 wid" v-if="roundtrip || oneway">
        <div style="font-size:16px;" class="row justify-content-center align-items-center pb-3">
          <div class="col-5 d-flex justify-content-end"><span class="fw-bold">{{ fromData }}</span></div>
          <div class="col-2" v-if="roundtrip">
            <v-icon>mdi-swap-horizontal</v-icon>
          </div>
          <div class="col-2" v-else>
            <v-icon>mdi-arrow-right</v-icon>
          </div>
          <div class="col-5 d-flex justify-content-start"><span class="fw-bold">{{ toData }}</span></div>
        </div>
        <div class="row pb-1" v-if="roundtrip">
            <div class="col-5 deda d-flex justify-content-end"><span>{{ dedate }}</span></div>
            <div class="col-2"><span>&#160;</span></div>
            <div class="col-5 reda  d-flex justify-content-start"><span>{{ returnDate }}</span></div>
        </div>
        <div class="row pb-1" v-else>
            <div class="col-12"><span>{{ dedate }}</span></div>
        </div>
        <div>
          <span v-if="roundtrip">RoundTrip</span>
          <span v-else>Oneway</span>
        </div>
      </div>
      <div class="text-center mt-4 wid"  v-if="multi">
        <div v-for="(data,index) in multiData.itinery" :key="index">
          <div style="font-size:16px;" class="row justify-content-center align-items-center pb-1">
            <div class="col-5"><span class="fw-bold">{{ data.from }}</span></div>
            <div class="col-2">
              <v-icon>mdi-arrow-right</v-icon>
              <!-- <p class="f-size-14 fw-500"> {{ getDate(data.depdate) }}</p> -->
            </div>
            <div class="col-5"><span class="fw-bold">{{ data.to }}</span></div>
          </div>
          <div class="row">
            <div class="col-12 text-center"><p>{{ getDate(data.departDate)}}</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  props: {
    searchCase: String
  },
  data() {
    return {
      portalLogo: "",
      fromData: "",
      toData: "",
      dedate: "",
      returnDate: "",
      tripType: "",
      adultcount:"", 
      childcount: "",
      infantcount: "",
      classType: "",

      multi: false,
      roundtrip: false,
      oneway: false,

      multiData:[],
      searchData:"",
      // items: [
      //   {
      //     src: require("@/assets/caro1.jpg"),
      //   },
      // ],
      
      progloader:true,
    };
  },


  methods: {

    loadSearchData(){
      const tabId = sessionStorage.getItem("tabId");
      const tripType = this.$route.query.tripType;
      // console.log(this.searchCase,'storedDatasdasdasdas...1')

      let key = '';

      if (tripType === 'RT' || tripType === 'OW' ) {
        key = tripType === 'RT'? `searchedData-round-${tabId}` : `searchedData-oneway-${tabId}`;
        this.oneway = tripType === 'OW';
        this.roundtrip = tripType === 'RT';
        // console.log(key,'storedDatasdasdasdas...2');
      }
      else if (tripType === 'MC') {
        key = `searchedData-multicity-${tabId}`;
        this.multi = true;
        // console.log(key,'storedDatasdasdasdas...3');
      }

      const storedData = localStorage.getItem(key);
      // console.log(storedData,'storedDatasdasdasdas...4')


      if (storedData) {
        if (this.multi) {
          this.multiData = JSON.parse(storedData) || this.searchCase;
          this.adultcount = this.multiData.adult;
          this.childcount = this.multiData.child;
          this.infantcount = this.multiData.infant;
          this.classType = this.multiData.class;
          // console.log(this.multiData,'storedDatasdasdasdas...5');
          console.log(this.adultcount,this.childcount,this.infantcount,'storedDatasdasdasdassdsds...5');

        } else {
          this.searchData = JSON.parse(storedData) || this.searchCase;
          // console.log(this.searchData,'storedDatasdasdasdas...6');

          this.fromData = this.searchData.from;
          this.toData = this.searchData.to;
          this.dedate = moment(this.searchData.dedate).format("DD MMM-YYYY");

          if(tripType === 'RT'){
            this.returnDate = moment(this.searchData.redate).format("DD MMM-YYYY");
          }
          this.adultcount = this.searchData.adult;
          this.childcount = this.searchData.child;
          this.infantcount = this.searchData.infant;
          this.classType = this.searchData.class;
          this.travelType = tripType;

        }
      } else {
        console.log('No search data found for this tab.');
      }

      console.log(this.dedate, "mutiDatamutiData");
    },

    getDate(data){
      return moment(data).format("DD MMM-YYYY")
    },
    getConfigFunc() {
      const getConfigData = getConfigDataFromLocalStorage();

      console.log(getConfigData, "LOADERRR");

      if (getConfigData) {
        this.portalLogo = getConfigData.payload.portal_configuration.logo_path;
        console.log(this.portalLogo,'asdasdaportalLogo');
        
      }
    },
  },
  watch: {
    searchCase(newValue) {
      // this.searchData = newValue;
      if (newValue) {
        this.loadSearchData(); 
      }
    },
  },

  
  mounted() {
    this.getConfigFunc();
    this.loadSearchData();
  },
};
</script>

<style scoped>
.preloader-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preloader {
  text-align: center;
}
.wid
{
  width: 560px;
}
@media only screen and (max-width: 768px){
.wid
{
    width: 85%;
}
.deda
{
  margin-left: -8px;
}
.reda{
  padding-left: 45px;
  /* padding: 0px !important; */
}
.preloader {
  text-align: center;
  margin-top: -20px;
}  
}
</style>